'use strict';

//libraries
var React = require('react');

//constants
var ContentService = require('../../services/ContentService');
var Products = require('../../utils/Products.js');
var YourDetailsActions = require('../../actions/YourDetailsActions.js');
var appConstants = require('../../constants/ApplicationConstants.js');
var YesNoRadioData = require('../../constants/ApplicationConstants.js').YesNoRadioData;
var ApplicationHelper = require('../../utils/ApplicationHelper');
var ProductIds = appConstants.ProductIds;
var FormKeys = appConstants.FormKeys;
var tfnTypes = appConstants.tfnTypes;

var TextInput = require('../Common/TextInput.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var SelectInput = require('../Common/SelectInput.jsx');

var _ = require('lodash');

var Tfn = React.createClass({
    propTypes: {
        index: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
        type: React.PropTypes.oneOf([tfnTypes.individual, tfnTypes.business]),
        section: React.PropTypes.string,
        productId: React.PropTypes.number,
        accountType: React.PropTypes.string,
        isMainApplicant: React.PropTypes.bool,
        tfnNumberIsMandatory: React.PropTypes.bool,
        tfnNumberReadonly: React.PropTypes.bool,
        hasTfnExemptionReadonly: React.PropTypes.bool,
        tfnExemptionReasonReadonly: React.PropTypes.bool,
        tfnNumberRightText: React.PropTypes.string,
        tfnConsentFlag: React.PropTypes.string,
        tfnWithConsent: React.PropTypes.string,
        askForTfnExplicitConsent: React.PropTypes.bool,
        hasTfnExemptionIsMandatory: React.PropTypes.bool,
        hasTfnExemptionRightText: React.PropTypes.string,
        underAge60: React.PropTypes.bool,
        errorList: React.PropTypes.array
    },

    getDefaultProps: function () {
        return {
            type: tfnTypes.individual,
            index: '',
            section: '',
            tfnNumberIsMandatory: true,
            tfnNumberReadonly: false,
            hasTfnExemptionIsMandatory: true,
            hasTfnExemptionReadonly: false,
            tfnExemptionReasonReadonly: false,
            tfnConsentFlag: null,
            tfnWithConsent: '',
            askForTfnExplicitConsent: false
        };
    },
    isTfnValid: function (tfnNumberId, tfnNumber) {
        return tfnNumber && !(_.filter(this.props.errorList, { id: tfnNumberId })).length
    },

    onSelectTfnReuse: function(event){
        var { model: fieldId, id: componentId, value: fieldValue} = event.target;
        YourDetailsActions.updateYourDetailsData(fieldId, componentId, fieldValue, this.props.index);
    },

    updateTfn: function (event) {
        var { model: fieldId, id: componentId, value: fieldValue } = event.target;

        if (fieldValue && fieldValue.length < 8 && event.type === 'keyup')
            return;

        YourDetailsActions.updateYourDetailsData(fieldId, componentId, fieldValue, this.props.index);
    },

    renderTfnConsentFlag: function(content){        
        return <RadioInput id={'tfnConsentFlag'}
                        data={YesNoRadioData}
                        value={this.props.tfnConsentFlag}
                        label={content.yourDetails.tfnAskForReuseQuestion}
                        labelRightText={content.yourDetails.tfnAskForReuseQuestionRightText}
                        onChange={this.onSelectTfnReuse}
                        model="tfnConsentFlag"
                        mandatory={true}
                        helpText={content.yourDetails[this.props.productId].tfnAskForReuseQuestionHelpText}
                        errorList={this.props.errorList} />;
    },

    renderExistingTfnAndExplicitConsentFlag: function (content, tfnMessage){
        return (
            <div>
                {this.renderExistingTfn(tfnMessage)}
            </div>
        );
    },

    renderExistingTfn: function(tfnMessage) {
        return <TextInput   id={this.props.section + 'tfnNumber' + this.props.index}
                            label="Your Existing TFN is:"
                            value={this.props.tfnNumber}
                            mandatory={this.props.tfnNumberIsMandatory} 
                            isDisabled={true}
                            isHidden={false}
                            contextualMessage={this.props.type === tfnTypes.business ? undefined : tfnMessage} />;
    },

    renderTfnWithConsent: function(tfnMessage){
        return <TextInput   id={this.props.section + 'tfnWithConsent' + this.props.index}
                            label={this.getTfnNumberLabel()}
                            ref="tfnWithConsent"
                            value={this.props.tfnWithConsent}
                            errorList={this.props.errorList}
                            onKeyUp={this.updateTfn}
                            onBlur={this.updateTfn}
                            model="tfnWithConsent"
                            mandatory={this.props.tfnNumberIsMandatory}
                            rightText={this.props.tfnNumberRightText} 
                            contextualMessage={this.props.type === tfnTypes.business ? undefined : tfnMessage} />
    },

    renderTfnInput: function(onTfnInputChange, tfnMessage) {
        return <TextInput   id={this.props.section + 'tfnNumber' + this.props.index }
                            label={this.getTfnNumberLabel()}
                            ref="tfnNumber"
                            value={this.props.tfnNumber}
                            errorList={this.props.errorList}
                            onKeyUp={onTfnInputChange}
                            onBlur={onTfnInputChange}
                            model="tfnNumber"
                            mandatory={this.props.tfnNumberIsMandatory}
                            rightText={this.props.tfnNumberRightText}
                            contextualMessage={this.props.type === tfnTypes.business ? undefined : tfnMessage}
                            isDisabled={this.props.tfnNumberReadonly} />;
    },
        

    renderTfnInputAndExplicitConsentFlag: function (content, onTfnInputChange, tfnMessage, prePopulated, isTfnExplicitConsentAvailable) {
        return (
            <div>
                {
                    prePopulated && isTfnExplicitConsentAvailable
                    ? this.renderTfnWithConsent(tfnMessage)
                    : this.renderTfnInput(onTfnInputChange, tfnMessage)
                }
            </div>
        );
    },

    renderTfnInputs: function (onTfnInputChange) {
        const content = ContentService.getContent();
        let tfnMessage = (this.props.productId && content.yourDetails[this.props.productId].tfnCopy)
                ? content.yourDetails[this.props.productId].tfnCopy
                : content.yourDetails.tfnCopy;
        if (this.props.productId === ProductIds.PENSION && (!this.props.underAge60)) {
            tfnMessage = content.yourDetails[this.props.productId].tfnAboveAge60;
        }
        
        const isMainApplicant = !ApplicationHelper.isBusinessAccountType(this.props.accountType) || this.props.isMainApplicant;
        const isPension = Products.isPension(this.props.productId);
        const isSuper = Products.isSuper(this.props.productId);
        const isPensionOrSuper = isPension || isSuper;
        const isTfnExplicitConsentAvailable = isPensionOrSuper || (Products.isInvestment(this.props.productId) && isMainApplicant);
        const isTfnPrePopulated = this.props.tfnNumber && this.props.tfnNumberReadonly && isTfnExplicitConsentAvailable;
        
        if (isTfnPrePopulated) {
            return (<div>
                        {this.renderTfnConsentFlag(content)}  
                        {
                            this.props.tfnConsentFlag === appConstants.YesNoValues.YES
                            ? this.renderExistingTfnAndExplicitConsentFlag(content, tfnMessage)
                            : this.props.tfnConsentFlag === appConstants.YesNoValues.NO
                            ? this.renderTfnInputAndExplicitConsentFlag(content, onTfnInputChange, tfnMessage, true, isTfnExplicitConsentAvailable)
                            : null
                        }
                </div>);
        } else {
            return this.renderTfnInputAndExplicitConsentFlag(content, onTfnInputChange, tfnMessage, false, isTfnExplicitConsentAvailable);
        }
    },

    renderHasTfnExemptionRadio: function(onTfnInputChange){
        return <RadioInput  label="Select one of the following"
                            id={this.props.section + 'hasTfnExemption' + this.props.index}
                            ref="hasTfnExemption"
                            data={this.getEnterTfnData()}
                            value={this.props.hasTfnExemption}
                            onChange={onTfnInputChange}
                            errorList={this.props.errorList}
                            mandatory={this.props.hasTfnExemptionIsMandatory}
                            rightText={this.props.hasTfnExemptionRightText}
                            model="hasTfnExemption"
                            isHidden={this.hasNoExemptionOption()} 
                            disabled={this.props.hasTfnExemptionReadonly} />;
    },

    renderTfnExemptionReason: function(){
        const hideExemptionReason = this.hasNoExemptionOption() || !(this.props.hasTfnExemption === appConstants.YesNoValues.YES);
        var onChangeExemptionReason = this.props.onChangeExemptionReason || this.updateTfn;

        return <SelectInput label="Select exemption reason"
                            id={this.props.section + 'tfnExemptionReason' + this.props.index}
                            ref="tfnExemptionReason"
                            onChange={onChangeExemptionReason}
                            onBlur={onChangeExemptionReason}
                            options={this.props.tfnExemptionList}
                            value={this.props.tfnExemptionReason}
                            customClass="form-horizontal"
                            className="select-tfn-exemption"
                            isHidden={hideExemptionReason}
                            model="tfnExemptionReason"
                            errorList={this.props.errorList}
                            disabled={this.props.tfnExemptionReasonReadonly} />;
    },

    hasNoExemptionOption: function(){
        return Products.isPension(this.props.productId) 
        || Products.isSuper(this.props.productId) 
        || this.props.formKey === FormKeys.PARTNERSHIP_INVESTMENT 
        || this.props.formKey === FormKeys.SMSF_INVESTMENT;
    },

    getTfnNumberLabel: function(){
        return this.props.type === tfnTypes.business ? 'Enter the Tax File Number (TFN)' : 'Enter your Tax File Number (TFN)';
    },

    getEnterTfnData: function(){
        var tfnNumberLabel = this.getTfnNumberLabel();
        var enterTfnData = 
                this.props.hasTfnExemption === appConstants.YesNoValues.NO 
            ||  this.props.hasTfnExemption === appConstants.YesNoValues.YES
            ? 
                [
                    { id: appConstants.YesNoValues.NO, name: tfnNumberLabel, isHidden: false },
                    { id: appConstants.YesNoValues.YES, name: 'Select exemption reason', isHidden: false },
                    { id: appConstants.Clear, name: 'Clear selection', isHidden: false }
                ]
            : 
                [
                    { id: appConstants.YesNoValues.NO, name: tfnNumberLabel, isHidden: false },
                    { id: appConstants.YesNoValues.YES, name: 'Select exemption reason', isHidden: false }
                ];

        return enterTfnData;
    },

    render: function() {
        var onTfnInputChange = this.props.onChange || this.updateTfn;

        return (
            <div>
                {this.renderHasTfnExemptionRadio(onTfnInputChange)}
                { 
                    this.hasNoExemptionOption() || this.props.hasTfnExemption === appConstants.YesNoValues.NO 
                    ? this.renderTfnInputs(onTfnInputChange) 
                    : null
                }
                {this.renderTfnExemptionReason()}
            </div>
        );
    }
});

module.exports = Tfn;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/Tfn.jsx